import { render, staticRenderFns } from "./activityDetectionJg.vue?vue&type=template&id=67688455&scoped=true"
import script from "./activityDetectionJg.vue?vue&type=script&lang=js"
export * from "./activityDetectionJg.vue?vue&type=script&lang=js"
import style0 from "./activityDetectionJg.vue?vue&type=style&index=0&id=67688455&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67688455",
  null
  
)

export default component.exports